import { type EstimationType } from '../lib/Estimate';
import { type WorkUnitEnum_value } from '../models/generated/types';
import ItemFilter, { type FilterOption } from './ItemFilter';

export type EstimateTypeFilterValue = EstimationType | 'count' | 'time';

export default class EstimateTypeFilter extends ItemFilter<EstimateTypeFilterValue> {
  constructor({
    initialItems = ['count'],
    capacityUnits,
    showRemainingEstimate,
  }: {
    initialItems: EstimateTypeFilterValue[];
    capacityUnits?: WorkUnitEnum_value;
    showRemainingEstimate?: boolean;
  }) {
    const initialOptions = EstimateTypeFilter.initOptions({
      capacityUnits,
      showRemainingEstimate,
    });
    super(initialItems, initialOptions);
  }

  static initOptions({
    capacityUnits,
    showRemainingEstimate,
  }: {
    capacityUnits?: WorkUnitEnum_value;
    showRemainingEstimate?: boolean;
  }): FilterOption<EstimateTypeFilterValue>[] {
    const estimationUnits = capacityUnits === 'POINTS' ? 'Points' : 'Time';
    const initialOptions: FilterOption<EstimateTypeFilterValue>[] = [
      { text: 'Records completed', value: 'count', label: 'Records Completed' },
      {
        text: 'Detailed estimate',
        value: 'originalEstimate',
        label: `Detailed estimate (${estimationUnits})`,
      },
      ...(showRemainingEstimate
        ? ([
            {
              text: `Actual effort`,
              value: 'remainingEstimate',
              label: `Effort logged (${estimationUnits})`,
            },
          ] as const)
        : []),
    ];
    return initialOptions;
  }
}
